module.exports = __webpack_public_path__ + "static/media/KaTeX_Size3-Regular.397bd687.woff2";